/**
 * The registrant's onboarding plan, as the wizard reads it.
 *
 * Which screens come next is decided by the backend (clinics.services.onboarding);
 * the wizard only needs this for its ONE client-side jump — the bank-connected
 * screen's Next goes straight to the invite screen without a backend write — and
 * for what the invite screen shows. A missing plan (older backend, network error)
 * reads as today's behaviour: the full invite screen.
 */
export const INVITES_FULL = "full";
export const INVITES_OFFICES_ONLY = "offices_only";
export const INVITES_NONE = "none";

export function invitesMode(plan) {
  const mode = plan && plan.invites_screen;
  return [INVITES_FULL, INVITES_OFFICES_ONLY, INVITES_NONE].includes(mode) ? mode : INVITES_FULL;
}

/** After the bank-connected screen: show the invite screen, or skip past it. */
export function afterBankAction(plan) {
  return invitesMode(plan) === INVITES_NONE ? "skip" : "invite";
}
